import { render, staticRenderFns } from "./CourseNavigation.vue?vue&type=template&id=4a65ef0d&scoped=true"
import script from "./CourseNavigation.vue?vue&type=script&lang=ts"
export * from "./CourseNavigation.vue?vue&type=script&lang=ts"
import style0 from "./CourseNavigation.vue?vue&type=style&index=0&id=4a65ef0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a65ef0d",
  null
  
)

export default component.exports